'use strict';

const THEME_COOKIE_NAME = "aviary-theme";
const COOKIE_MAX_AGE = 365 * 24 * 60 * 60; // 1 year
const isServer = typeof window === "undefined";
/**
 * Gets the theme preference from the `aviary-theme` cookie
 */ const getThemeCookie = ()=>{
    if (isServer) {
        return null;
    }
    const cookies = document.cookie.split(";");
    const themeCookie = cookies.find((cookie)=>cookie.trim().startsWith(THEME_COOKIE_NAME));
    if (themeCookie) {
        const value = themeCookie.split("=")[1]?.trim();
        return value === "dark" || value === "light" ? value : null;
    }
    return null;
};
/**
 * Sets the theme preference in the `aviary-theme` cookie
 */ const setThemeCookie = (theme)=>{
    document.cookie = `${THEME_COOKIE_NAME}=${theme}; max-age=${COOKIE_MAX_AGE}; path=/; SameSite=Lax`;
};

exports.THEME_COOKIE_NAME = THEME_COOKIE_NAME;
exports.getThemeCookie = getThemeCookie;
exports.setThemeCookie = setThemeCookie;
//# sourceMappingURL=cookieThemeManager.cjs.map
